import { algebraKeysProps } from './algebraKeys'
import { functionKeysProps } from './functionKeys'
import { geometryKeysProps } from './geometryKeys'
import { greekLettersKeysProps } from './greekLetters'
import { majLettersKeysProps, minLettersKeysProps } from './letterKeys'
import { numberKeysProps } from './numberKeys'
import { operationKeysProps } from './operationKeys'
import { ponctuationKeysProps } from './ponctuationKeys'
import { setKeysProps } from './setKeys'
import { unitKeysProps } from './unitKeys'
import { utilityKeysProps } from './utilityKeys'
import { wordKeysProps } from './wordKeys'
import { integrationKeysProps } from './integrationKeys'

export const allKeysProps = [
  ...numberKeysProps,
  ...minLettersKeysProps,
  ...majLettersKeysProps,

  ...integrationKeysProps,
  ...operationKeysProps,
  ...functionKeysProps,
  ...utilityKeysProps,
  ...setKeysProps,
  ...greekLettersKeysProps,
  ...geometryKeysProps,
  ...algebraKeysProps,
  ...ponctuationKeysProps,
  ...unitKeysProps,
  ...wordKeysProps,
  {
    id: 'overrightarrow',
    label: '\\overrightarrow{AB}',
    labelType: 'tex',
    mathfieldInstructions: {
      content: 'overrightarrow',
      method: 'cmd',
    },
  },

  {
    id: 'underscore',
    label: '\\square_n',
    labelType: 'tex',
    mathfieldInstructions: { content: '_', method: 'cmd' },
    group: 'sequences',
  },
  {
    id: 'del',
    label: '\\bksp',
    labelType: 'tex',
    mathfieldInstructions: { content: 'Backspace', method: 'keystroke' },
    group: 'sequences',
  },
]

// export const KeysPropsMap = new Map(
//   allKeysProps.map((obj) => {
//     return [obj.id, obj]
//   }),
// )
